import React from 'react';
import './LoadingScreen.css';

interface LoadingScreenProps {
  /** Optional message to display below the logo */
  message?: string;
  /** Size of the logo */
  size?: 'small' | 'medium' | 'large';
  /** Whether to show fullscreen overlay */
  fullscreen?: boolean;
}

/**
 * Loading screen with pulsing company logo
 */
const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message,
  size = 'medium',
  fullscreen = true
}) => {
  const sizeValue = size === 'small' ? 48 : size === 'medium' ? 72 : 96;
  const logoSrc = '/assets/logo/LCTF Profile.png';

  return (
    <div className={`loading-screen ${fullscreen ? 'fullscreen' : 'inline'}`}>
      <div className="loading-logo-container">
        <img 
          src={logoSrc}
          alt="Loading"
          className="loading-logo pulse"
          style={{ width: sizeValue, height: sizeValue }}
          onError={(e) => {
            // Fallback if logo doesn't exist
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            const parent = target.parentElement;
            if (parent && !parent.querySelector('.loading-logo-fallback')) {
              const placeholder = document.createElement('div');
              placeholder.className = 'loading-logo-fallback pulse';
              placeholder.textContent = 'LCTF';
              placeholder.style.cssText = `
                width: ${sizeValue}px;
                height: ${sizeValue}px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: linear-gradient(135deg, #2C3E2F 0%, #4a5d4c 100%);
                color: white;
                font-weight: bold;
                border-radius: 12px;
                font-size: ${sizeValue * 0.35}px;
              `;
              parent.appendChild(placeholder);
            }
          }}
        />
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingScreen;
